export const NDE_TYPES = [
  'Ultrasonic',
  'Magnetic Particle',
  'X-Ray',
  'Eddy Current',
] as const
